/* nazifa-boot-rev-4 — ensure homepage shows packages shopper (5173 UX) */
(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;

  const template = main.getAttribute('data-template') || '';
  if (template && template !== 'index') return;

  if (main.querySelector('[data-nazifa-shopper]')) return;

  const stale =
    main.querySelector('[id*="__featured_products"]') ||
    main.querySelector('[data-testid="product-list"]')?.closest('[id^="shopify-section-"]') ||
    main.querySelector('.ui-test-product-list')?.closest('[id^="shopify-section-"]');

  if (!stale) return;

  const ensureAssets = (html) => {
    const cssMatch = html.match(
      /href="(\/\/cdn\.shopify\.com\/[^"]*nazifa-series-shopper\.css[^"]*)"/
    );
    if (cssMatch && !document.querySelector('link[href*="nazifa-series-shopper.css"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `https:${cssMatch[1]}`;
      document.head.appendChild(link);
    }

    const ensureScript = (needle) => {
      if (document.querySelector(`script[src*="${needle}"]`)) return;
      const match = html.match(new RegExp(`src="(//cdn\\.shopify\\.com/[^"]*${needle}[^"]*)"`));
      if (!match) return;
      const script = document.createElement('script');
      script.src = `https:${match[1]}`;
      script.defer = true;
      document.body.appendChild(script);
    };

    ensureScript('nazifa-sku-specs.js');
    ensureScript('nazifa-series-shopper.js');
  };

  fetch('/collections/sumruh', {
    headers: { Accept: 'text/html' },
    credentials: 'same-origin',
  })
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next =
        doc.querySelector('[id*="__packages_shopper"]') ||
        doc.querySelector('[id*="__series_shopper"]') ||
        doc.querySelector('[data-nazifa-shopper]')?.closest('[id^="shopify-section-"]');
      if (!next || !next.querySelector('[data-nazifa-shopper]')) return;
      stale.replaceWith(next);
      ensureAssets(html);
    })
    .catch(() => {
      /* keep original homepage grid */
    });
})();
